export default __webpack_public_path__ + "static/media/production.2831d64b.webp";